// Matriz impacto × urgencia → prioridad (PROMPT_MAESTRO.md §6.5).
export const LEVELS = ['high', 'medium', 'low'];
export const PRIORITIES = ['P1', 'P2', 'P3', 'P4'];
export const IMPACT_LABEL = {
    high: 'Alto · toda la empresa o la nómina detenida',
    medium: 'Medio · un área o grupo de empleados',
    low: 'Bajo · un usuario, hay alternativa'
};
export const URGENCY_LABEL = {
    high: 'Alta',
    medium: 'Media',
    low: 'Baja'
};
export const PRIORITY_LABEL = {
    P1: 'P1 · Crítica',
    P2: 'P2 · Alta',
    P3: 'P3 · Media',
    P4: 'P4 · Baja'
};
const MATRIX = {
    high: { high: 'P1', medium: 'P2', low: 'P3' },
    medium: { high: 'P2', medium: 'P3', low: 'P4' },
    low: { high: 'P3', medium: 'P4', low: 'P4' }
};
export function priorityFor(impact, urgency) {
    return MATRIX[impact][urgency];
}
/** Prioridad efectiva: la sobrescrita (con justificación) o la calculada. */
export function effectivePriority(impact, urgency, override) {
    return override?.value ?? priorityFor(impact, urgency);
}
//# sourceMappingURL=priority.js.map